import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "react-bootstrap/Button";
import { Link, useNavigate, useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { createAboutUsTeamParagraph, getAboutUsTeamParagraph, updateAboutUsTeamParagraph } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";
import { Formik } from "formik";
import * as Yup from "yup";

export default function MeetParagraphEdit() {
    const { id, partnerId } = useParams();
    const navigate = useNavigate();
    const [teamParagraph, setTeamParagraph] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const validationSchema = Yup.object().shape({
        paragraph: Yup.string().required("Paragraph is required"),
    });

    const fetchTeamParagraphData = async () => {
        setIsLoading(true);
        if (!Number(id)) {
            setIsLoading(false);
            return;
        }
        try {
            const response = await getAboutUsTeamParagraph(id);
            const teamParagraphData = response.data.data[0];
            setTeamParagraph(teamParagraphData);
            console.log(response.data.data[0]);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTeamParagraphData();
    }, [id]);

    const handleSubmit = async (values, { setSubmitting }) => {
        if (values.paragraph.length > 100) {
            showToast({
                type: 'error',
                message: "Paragraph must be less than 100 characters.",
            });
            setSubmitting(false);
            return;
        }

        const formData = {
            paragraph: values.paragraph,
        };

        try {
            if (!Number(id)) {
                formData.partner_id = partnerId;
                const response = await createAboutUsTeamParagraph(formData);
                console.log(response);
                if (response.status === 200) {
                    showToast({
                        type: 'success',
                        message: response?.data?.message || "Paragraph section has been create successfully!",
                    });
                    const paragraphData = response.data.data;
                    setTeamParagraph(paragraphData);
                    if (paragraphData && paragraphData.id) {
                        navigate(`/${partnerId}/aboutus/meet_the_team/paragraph/edit/${paragraphData.id}`);
                    }
                } else {
                    showToast({
                        type: 'error',
                        message: response?.data?.message || "Failed to create paragraph section. Please try again.",
                    });
                }
            } else {
                const response = await updateAboutUsTeamParagraph(id, formData);
                console.log(response);
                if (response.status === 200) {
                    showToast({
                        type: 'success',
                        message: response?.data?.message || "Paragraph section has been updated successfully!",
                    });
                    console.log("success");
                } else {
                    showToast({
                        type: 'error',
                        message: response?.data?.message || "Failed to update paragraph section. Please try again.",
                    });
                }
            }
        } catch (error) {
            showToast({
                type: 'error',
                message: error?.response?.data?.message || "Failed to update paragraph section. Please try again.",
            });
            console.log(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            {isLoading ? <CmsCircularProgress /> :
                <FormWrapper>
                    <Title>{Number(id) ? 'Edit' : 'Add'} Paragraph Section</Title>
                    <SliderDiv>
                        <Formik
                            initialValues={{
                                paragraph: teamParagraph?.paragraph || "",
                            }}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                            }) => (
                                <Form onSubmit={handleSubmit}>
                                    <FormGroup 
                                        label="Enter a paragraph"
                                        requiredField={true}
                                        error={touched.paragraph && errors.paragraph}
                                    >
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="paragraph"
                                            value={values.paragraph}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={touched.paragraph && errors.paragraph}
                                        />
                                    </FormGroup>
                                    <br />
                                    <ButtonWrapper>
                                        <Link to={`/${partnerId}/aboutus/meet_the_team/view/${Number(id) ? id : 'create'}`}>
                                            <Button variant="secondary">Go Back</Button>
                                        </Link>
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Saving..." : "Save Changes"}
                                        </Button>
                                    </ButtonWrapper>
                                </Form>
                            )}
                        </Formik>
                    </SliderDiv>
                </FormWrapper>}
        </>
    );
}
const FormWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
   @media (max-width: 890px) {
  gap: 2rem;
}
 @media (max-width: 425px) {
  gap: 1rem;
}
`;